module.exports = __webpack_public_path__ + "img/Avatar1.677cfff3.png";